import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Label } from '../../../components/Label';
import { FormItem } from '../../../components/FormItem';
import type { InputDefaultProps } from '../types';
import { CustomTextArea } from './styles';

export function ActivityDescription({ fieldName }: Readonly<InputDefaultProps>): JSX.Element {
	const title = `${I18n.get('Activity description')} (${I18n.get('productivity')})`;
	const placeholder = I18n.get('Activity description');

	return (
		<Col span={24}>
			<Row gutter={[0, 10]}>
				<Col span={24}>
					<Label isRequired>{title}</Label>
				</Col>
				<Col span={24}>
					<FormItem
						name={[fieldName, 'activity_description']}
						rules={[{ required: true, message: I18n.get('Enter the activity description') }]}
					>
						<CustomTextArea showCount placeholder={placeholder} maxLength={500} rows={10} />
					</FormItem>
				</Col>
			</Row>
		</Col>
	);
}
